import React from 'react';

import { ChordBracing, ChordBracingSettings } from '@paragon/contract-library';

import { getActiveAnalysisSet } from '../../../../store/selectors/getActiveAnalysisSetSelector';
import { useAppSelector } from '../../../hooks';
import {
  BottomChordBracingSettings,
  FlatTopChordBracingSettings,
  SlopedTopChordBracingSettings,
} from './ChordBracingSettings';

interface Props {
  readonly disabled?: boolean;
  readonly chordBracingArray: readonly ChordBracing[];
  readonly setChordBracing: (
    chordBracingProperty: keyof ChordBracing,
    chordBracingSettingsProperty: keyof ChordBracingSettings,
    value: boolean | number,
  ) => void;
}

const ChordBracingSubPanel = ({ disabled, chordBracingArray, setChordBracing }: Props) => {
  const activeAnalysisSet = useAppSelector(getActiveAnalysisSet);
  const calculatedSlopedTopChordPurlinSpacing =
    activeAnalysisSet && activeAnalysisSet.calculatedSlopedTopChordPurlinSpacing;
  const calculatedBottomChordPurlinSpacing = activeAnalysisSet && activeAnalysisSet.calculatedBottomChordPurlinSpacing;
  const calculatedFlatTopChordPurlinSpacing =
    activeAnalysisSet && activeAnalysisSet.calculatedFlatTopChordPurlinSpacing;

  const setSlopedTopChordIsSheathed = (isSheathed: boolean) =>
    setChordBracing('slopedTopChordBracingSettings', 'isSheathed', isSheathed);
  const setSlopedTopChordUseMaxPurlinSpacing = (useMaxPurlinSpacing: boolean) =>
    setChordBracing('slopedTopChordBracingSettings', 'useMaxPurlinSpacing', useMaxPurlinSpacing);
  const setSlopedTopChordPurlinSpacing = (value: number) =>
    setChordBracing('slopedTopChordBracingSettings', 'purlinSpacing', value);
  const setBottomChordIsSheathed = (isSheathed: boolean) =>
    setChordBracing('bottomChordBracingSettings', 'isSheathed', isSheathed);
  const setBottomChordUseMaxPurlinSpacing = (useMaxPurlinSpacing: boolean) =>
    setChordBracing('bottomChordBracingSettings', 'useMaxPurlinSpacing', useMaxPurlinSpacing);
  const setBottomChordPurlinSpacing = (value: number) =>
    setChordBracing('bottomChordBracingSettings', 'purlinSpacing', value);
  const setFlatTopChordIsSheathed = (isSheathed: boolean) =>
    setChordBracing('flatTopChordBracingSettings', 'isSheathed', isSheathed);
  const setFlatTopChordUseMaxPurlinSpacing = (useMaxPurlinSpacing: boolean) =>
    setChordBracing('flatTopChordBracingSettings', 'useMaxPurlinSpacing', useMaxPurlinSpacing);
  const setFlatTopChordPurlinSpacing = (value: number) =>
    setChordBracing('flatTopChordBracingSettings', 'purlinSpacing', value);

  const slopedTopChordBracingSettings = chordBracingArray.map(
    (chordBracing) => chordBracing.slopedTopChordBracingSettings,
  );
  const flatTopChordBracingSettings = chordBracingArray.map((chordBracing) => chordBracing.flatTopChordBracingSettings);
  const bottomChordBracingSettings = chordBracingArray.map((chordBracing) => chordBracing.bottomChordBracingSettings);

  return (
    <div>
      <SlopedTopChordBracingSettings
        disabled={disabled}
        chordBracingSettings={slopedTopChordBracingSettings}
        calculatedMaxPurlinSpacing={chordBracingArray.length === 1 ? calculatedSlopedTopChordPurlinSpacing : null}
        onSetIsSheathed={setSlopedTopChordIsSheathed}
        onSetUseMaxPurlinSpacing={setSlopedTopChordUseMaxPurlinSpacing}
        onSetChordPurlinSpacing={setSlopedTopChordPurlinSpacing}
      />
      <FlatTopChordBracingSettings
        disabled={disabled}
        chordBracingSettings={flatTopChordBracingSettings}
        calculatedMaxPurlinSpacing={calculatedFlatTopChordPurlinSpacing}
        onSetIsSheathed={setFlatTopChordIsSheathed}
        onSetUseMaxPurlinSpacing={setFlatTopChordUseMaxPurlinSpacing}
        onSetChordPurlinSpacing={setFlatTopChordPurlinSpacing}
      />
      <BottomChordBracingSettings
        disabled={disabled}
        chordBracingSettings={bottomChordBracingSettings}
        calculatedMaxPurlinSpacing={calculatedBottomChordPurlinSpacing}
        onSetIsSheathed={setBottomChordIsSheathed}
        onSetUseMaxPurlinSpacing={setBottomChordUseMaxPurlinSpacing}
        onSetChordPurlinSpacing={setBottomChordPurlinSpacing}
      />
    </div>
  );
};

export default ChordBracingSubPanel;
